<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="im-frame">
        <svg
          class="im-svg"
          viewBox="0 0 240 140"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden="true"
        >
          <rect
            x="0"
            y="0"
            width="240"
            height="140"
            fill="#E6F0FA"
          />
          <circle
            cx="186"
            cy="34"
            r="14"
            fill="#FFD66B"
          />
          <polygon points="0,140 70,72 110,108 150,60 200,108 240,84 240,140" fill="#7AAED1" />
          <polygon points="0,140 60,90 100,118 140,82 200,118 240,104 240,140" fill="#3F6B8C" />
        </svg>
        <span class="im-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14">
            <path
              d="M21 17V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8.5 11l2.5 3 3.5-4.5L19 17H5l3.5-6z"
              fill="rgba(15,15,20,0.55)"
            />
          </svg>
        </span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewImage',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.im-frame {
  position: relative;
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  min-height: 150px;
  background: #E6F0FA;
}
.im-svg {
  display: block;
  width: 100%;
  height: 100%;
}
.im-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 6px;
}
</style>
